<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 21.5v-2h5v-5l-8-9v-2h18v2l-8 9v5h5v2H6Zm1.45-14h9.1l1.8-2H5.65l1.8 2Z"
    />
  </svg>
</template>
